<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="produtos"
      :loading="loading"
      :server-items-length="produtos.length"
      class="mt-3"
      no-data-text="Nenhum Produto encontrado"
      loading-text="Carregando Produtos..."
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item.produto.cotacaoProduto.produto.descricao="{ item }">
        <px-span-tooltip v-if="checkCodigo(item.produto.cotacaoProduto.produto)"
                    top
                    :text="labelCodigo(item.produto.cotacaoProduto.produto)"
                    tooltip="Código interno"/>
        {{ item.produto.cotacaoProduto.produto.descricao }}
      </template>
      <template v-slot:item.produto.cotacaoProduto.quantidade="{ item }">
        {{ item.produto.cotacaoProduto.quantidade
          | number(getCurrencyFormat(item.produto.cotacaoProduto.produto.casasDecimais)) }}
      </template>
      <template v-slot:item.produto.precoUnitario="{ item }">
        <px-matriz-preco :produto="item" :hide-icms="false" :show-preco-target="false"/>
      </template>
      <template v-slot:item.produto.total="{ item }">
        {{ item.produto.total | currency('R$', item.produto.cotacaoProduto.produto.casasDecimais) }}
      </template>
      <template v-slot:item.options="{ item }">
        <template v-if="isRespondida(item.produto)
          && isAberta(item.produto) && !item.produto.$adicionado">
          <div class="text-right">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon
                       v-on="on"
                       @click="adicionar(item.produto)">
                  <v-icon>mdi-cart</v-icon>
                </v-btn>
              </template>
              <span>Adicionar item ao carrinho</span>
            </v-tooltip>
          </div>
        </template>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Vue from 'vue';
import { CasaDecimalUtils } from 'px-components';
import { SituacaoRespostaCotacaoProduto, SituacaoCotacao } from 'px-business-components';
import CarrinhoService from '@/modules/carrinho/carrinho-service';
import PxMatrizPreco from '../PxMatrizPreco.vue';

export default {
  props: {
    produtos: {
      type: Array,
    },
  },
  computed: {
    isRespondida() {
      return item => item.situacao
        === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    isAberta() {
      return item => item.cotacaoProduto.situacao
        === SituacaoCotacao.keys.ABERTA.key;
    },
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `(${item.codigo})`;
    },
    getCurrencyFormat() {
      return casasDecimais => CasaDecimalUtils.getCurrencyFormat(casasDecimais);
    },
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'Descrição',
          sortable: true,
          value: 'produto.cotacaoProduto.produto.descricao',
        },
        {
          text: 'Quantidade',
          sortable: false,
          value: 'produto.cotacaoProduto.quantidade',
        },
        {
          text: 'Preço Unitário',
          sortable: false,
          value: 'produto.precoUnitario',
        },
        {
          text: 'Total',
          sortable: false,
          value: 'produto.total',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
          align: 'right',
        },
      ],
    };
  },
  methods: {
    adicionar(item) {
      this.loading = true;
      CarrinhoService.adicionarProduto(item.id)
        .then(() => {
          this.$toast('Item adicionado ao carrinho', { color: 'success' });
          Vue.set(item, '$adicionado', true);
          this.$emit('update');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    PxMatrizPreco,
  },
};

</script>
